import { tv } from '@change/ds-utils';

export const postTitleContainerStyles = tv({
	base: 'flex flex-col bg-[#E3E3E3] pb-[6px] pt-[4px]',
	variants: {
		isExpanded: {
			false: 'px-1.5',
			true: 'px-2.5',
		},
	},
});

export const profileContainerStyles = tv({
	base: 'w-[69%]',
	variants: {
		isExpanded: {
			false: 'px-0',
			true: 'px-1',
		},
	},
});

export const changeDotOrgCaptionStyles = tv({
	base: 'font-medium leading-[150%] tracking-[-0.088px]',
	variants: {
		isExpanded: {
			false: 'text-[8px]',
			true: 'text-xs',
		},
	},
});

export const petitionTitleStyles = tv({
	base: 'font-bold leading-[125%] tracking-[-0.099px]',
	variants: {
		isExpanded: {
			false: 'text-[9px]',
			true: 'text-[13px]',
		},
	},
});
